
import moment from 'moment';
import modelBase from "../../../../models/model-base.model";
import userMapModel from '../../../../models/user/user-map.model';
import userModel from '../../../../models/user/user.model';
import ViewBase from '../../../view-base.view';
import UserCreateInfoFormView from '../create/user-create-info-form.view';
import { formats as FORMATS } from "../../../../config/constants";

export default function UserEditInfoView() {
    ViewBase.call(this);
    let _userInfo = {};

    let _isInfoValid = true;
    let needToValidate = false;
    let defaultCountry = {
        code: '',
        name: '',
        isChanged: true,
        countryMapLoaded: false,
        countryUdfLoaded: false,
        seaoUser: false,
    };

    let onClose = (isDetailsDtlOpen) => { }

    const getInfo = (info, isValid) => {
        _isInfoValid = isValid;
    }

    const getUserDetails = (encryptedUserId) => {
        userModel.getUserDetails(
            (result) => {
                if (result?.data) {
                    defaultCountry.code = result.data.countryCode;
                    setInfoForm(result.data);
                }
            }, (error) => {
                this.handleError(error);
            },
            encryptedUserId);
    }

    const getUserDvisionMap = (userId, countryCode) => {
        _userInfo.divisionGroup = [];
        userMapModel.getByUser(
            (result) => {
                result?.forEach(element => {
                    _userInfo.divisionGroup.push(element.mapData);
                });
            }, (error) => {
                this.handleError(error);
            },
            countryCode, "Division", userId);
    }

    const setInfoForm = (userInfo) => {
        var ret = {
            userId: userInfo.userID,// "string",
            password: null,// "string",
            userType: userInfo.userType,// "string",
            countryCode: userInfo.countryCode,// "string",
            divisionGroup: [userInfo.divisionGroup],// ["string"], /////////////////////////////
            knoxID: userInfo.singleID,// "string",
            userName: userInfo.userName,// "string",
            email: userInfo.email,// "string",
            languageCode: userInfo.languageCode,// "string",
            mobileNumber: userInfo.mobileNumber,// "string",
            userStatus: userInfo.statusCode,// "string",
            salesForceYN: userInfo.salesForceYN,// "string", 
            salesForceType: userInfo.salesForceType,// "string",
            salesForceRankType: userInfo.salesForceRankType,// "string",
            employmentType: userInfo.employmentType,// "string",
            userGrade: userInfo.userGrade,// "string",
            supervisor: userInfo.supervisor,// "string",
            supervisorName: userInfo.supervisorName,// "string",
            agencyCode: userInfo.agency,// "string",
            dateOfBirth: moment(userInfo.dateOfBirth, "YYYYMMDD").isValid() ? moment(userInfo.dateOfBirth).format(FORMATS.apiDateFormat) : null,//_formatDateYyyyMMdd(userInfo.dateOfBirth),// "string",
            jobStartDate: moment(userInfo.jobStartDate, "YYYYMMDD").isValid() ? moment(userInfo.jobStartDate).format(FORMATS.apiDateFormat) : null,//_formatDateYyyyMMdd(userInfo.jobStartDate),// "string",
            jobEndDate: moment(userInfo.jobEndDate, "YYYYMMDD").isValid() ? moment(userInfo.jobEndDate).format(FORMATS.apiDateFormat) : null,//_formatDateYyyyMMdd(userInfo.jobEndDate),// "string",
            educationDegreeCode: userInfo.educationDegree,// "string",
            gender: userInfo.gender,// "string",
            workingExperience: userInfo.workingExperience,// "string",
            previousCompany: userInfo.previousCompanyName,// "string",
            additionalInfo: userInfo.additionalInfo,// "string",
            photoGuid: userInfo.photoGuid,// "string",  /////////////////////////////
            seaoUser: userInfo.seaoUser == 'Y' ? "Y" : "N",// "string" /////////////////////////////
            faceRecognitionYN: userInfo.faceRecognitionYN

        };
        _userInfo = ret;
        getUserDvisionMap(_userInfo.userId, _userInfo.countryCode);
    }

    const beforeSubmit = () => {
        if (_isInfoValid) {
            if (_userInfo?.photo && _userInfo?.photo?.file) {
                modelBase.uploadfile(
                    (result) => {
                        _userInfo.photoGuid = result[0]?.id;
                        submit();
                    },
                    (error) => {
                        this.handleError(error);
                    },
                    _userInfo.photo.file, "User");
            }
            else {
                submit();
            }

        }
        else {
            needToValidate = true;
            this.showMessage(this.getText("EM00000310", "Please fill in all required fields."), this.getText("EM00000142", "Error"));
        }
    }

    const submit = () => {
        this.showLoading();
        userModel.editInfo(
            (result) => {
                this.hideLoading();
                onClose(false, result);
            }, (error) => {
                this.hideLoading();
                if (error.code == 400) {
                    this.showErrorMessage(error.response[0].message, this.getText("EM00000108", "Validation Error"))
                } else {
                    this.handleError(error);
                }
            },
            _userInfo);
    }

    return {
        oninit: (vnode) => {
            onClose = vnode.attrs.onClose;
            getUserDetails(vnode.attrs.encryptedUserId);
        },
        view: (vnode) => {
            return [
                m('.row',
                    m('div',
                        m(UserCreateInfoFormView, { submit: getInfo, defaultCountry, infoForm: _userInfo, isnew: '0', needToValidate }),
                        m("hr.my-4"),
                        m(".d-grid.g.ap-2.d-sm-flex.justify-content-sm-center",
                            m("button.btn.btn-primary.btn-lg.px-4.gap-3", { style: "margin-right:10px;", onclick: beforeSubmit }, this.getText("LT00000005", "Submit")),

                        ),
                    ),
                ),
                this.getBaseViews()];
        }
    }
}


